import { action } from 'typesafe-actions';

import { ProjectList } from 'client/ducks/projects-page/service';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import { YearsFilter } from '@interfaces/years-filter';

import * as types from './types';

export const fetchProjects = (params: OutreachRequestParams = {}) => action(types.FETCH_PROJECTS_PAGE, params);
export const fetchProjectsSuccess = (data: ProjectList, params: OutreachRequestParams) =>
    action(types.FETCH_PROJECTS_PAGE_SUCCESS, { data, params });
export const fetchProjectsError = (error: Error) => action(types.FETCH_PROJECTS_PAGE_ERROR, error);

export const fetchProjectsFilters = () => action(types.FETCH_PROJECTS_FILTERS);
export const fetchProjectsFiltersSuccess = (data: YearsFilter) =>
    action(types.FETCH_PROJECTS_FILTERS_SUCCESS, data);
export const fetchProjectsFiltersError = (error: Error) =>
    action(types.FETCH_PROJECTS_FILTERS_ERROR, error);
